import { Button } from '@canyon/ui/Button'
import { Form, FormControl, FormField, FormItem, FormLabel } from '@canyon/ui/Form'
import { Switch } from '@canyon/ui/Switch'
import { SubmitHandler, UseFormReturn } from 'react-hook-form'

import { TUserNotificationsForm } from '@/forms/types'

export const USER_NOTIFICATIONS_FORM_ID = 'user-notifications-form'

interface IUserNotificationsFormProps {
  form: UseFormReturn<TUserNotificationsForm>
  isSubmitting?: boolean
  onSubmit: SubmitHandler<TUserNotificationsForm>
}

export const UserNotificationsForm = ({
  form,
  isSubmitting = false,
  onSubmit,
}: IUserNotificationsFormProps) => {
  const isDirty = form.formState.isDirty

  return (
    <Form {...form}>
      <form
        className="space-y-4"
        id={USER_NOTIFICATIONS_FORM_ID}
        onSubmit={form.handleSubmit(onSubmit)}
      >
        <div className="flex flex-col space-y-2">
          <div className="flex flex-row space-x-6">
            <FormField
              control={form.control}
              name="enableJobNotifications"
              render={({ field }) => (
                <FormItem className="w-1/4 md:flex md:w-full md:flex-col">
                  <FormLabel>Enable Job Application Activity Notifications</FormLabel>
                  <FormControl>
                    <Switch
                      {...field}
                      checked={field.value}
                      onCheckedChange={field.onChange}
                      value={field?.value?.toString()}
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>
          <div className="flex flex-row space-x-6">
            <FormField
              control={form.control}
              name="enableJobRecommendationsNotifications"
              render={({ field }) => (
                <FormItem className="w-1/4 md:flex md:w-full md:flex-col">
                  <FormLabel>Enable Job Recommendation Notifications</FormLabel>
                  <FormControl>
                    <Switch
                      {...field}
                      checked={field.value}
                      onCheckedChange={field.onChange}
                      value={field?.value?.toString()}
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>
        </div>

        {isDirty && (
          <div className="sticky bottom-0 pt-4 pb-2 mt-6 border-t-0.5 border-border">
            <Button
              className="w-full"
              disabled={isSubmitting}
              loading={isSubmitting}
              type="submit"
              variant="primary"
            >
              Apply Changes
            </Button>
          </div>
        )}
      </form>
    </Form>
  )
}
